import { BaseDto } from '../base.dto';

export class BankingCompVoidRefundDto extends BaseDto {
  approvalId: number;
  orderId: number;
  orderPosTableProductId: number;
  lastOrderStatusId: number;
  discountTypeId: number;
  grossAmount: number;
  type: string;
  merchantId: number;
  merchantName: string;
  compRefundCategoryId: number;
  compRefundCategoryName: string;
  description: string;
  approvedUserId: number;
  approvedUserUserName: string;
  approvedEmployeeId: number;
  approvedEmployeeUserName: string;
}
